let user: string | null = null;

const ENABLE_JOURNAL = true;

export default {
  setUser: (name: string) => {
    console.log('Journal', 'Setting name', name);
    user = name;
  },

  write: (action: string, value?: string) => {
    // Might want to disable this in certain scenarios
    if (!ENABLE_JOURNAL) {
      return;
    }

    console.log('Journal', 'Write', user || 'N/A', action, value);
    window.postMessageBridge({
      journal: [user || 'N/A', action, value],
    });
  },
};
